/** İş emri tip bayrakları (garanti / kurulum / servis) → etiket. */

export const TIP_LABELS = ['Garanti', 'Kurulum', 'Servis'];

const FLAG = {
  Garanti: 'garanti',
  Kurulum: 'kurulum',
  Servis: 'servis',
};

export function formatIsEmriTipi(row) {
  if (!row || typeof row !== 'object') return '';
  const parts = [];
  if (row.garanti) parts.push('Garanti');
  if (row.kurulum) parts.push('Kurulum');
  if (row.servis) parts.push('Servis');
  return parts.join(', ');
}

/** MUI filter → API query (`tip=garanti&tip=servis`). */
export function tipFiltersToParams(filters) {
  if (!Array.isArray(filters) || !filters.length) return undefined;
  const out = [];
  filters.forEach((label) => {
    const key = FLAG[label];
    if (key) out.push(key);
  });
  return out.length ? out : undefined;
}

export function tipColumnOptions() {
  return {
    filter: true,
    sort: true,
    filterOptions: {
      fullWidth: true,
      names: TIP_LABELS,
      logic(value, filters) {
        if (!filters.length) return false;
        const parts = String(value || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
        // Seçilen tiplerden en az biri satırda olmalı (OR)
        return !filters.some((f) => parts.includes(f));
      },
    },
    customFilterListOptions: { render: (v) => `Tip: ${v}` },
  };
}

export const tipColumn = {
  name: 'tip',
  label: 'Tip',
  options: tipColumnOptions(),
};
